<template>
  <component :is="cardComponent" />
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'investingPullRevenue',
      'executedPullRevenue',
    ]),

    cardComponent() {
      const componentName =
        this.investingPullRevenue || this.executedPullRevenue
          ? 'PullRevenueCardActive.vue'
          : 'PullRevenueCardInit.vue'
      return () => import(`@/components/main/cards/pull-revenue/${componentName}`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
